import Column from 'components/atoms/column'
import Container from 'components/atoms/container'
import InBetweenSpacing from 'components/atoms/in-between-spacing'
import Text from 'components/atoms/text'
import NavBar from 'components/molecules/nav-bar'
import Body from 'components/organisms/body'
import Footer from 'components/organisms/footer'
import Header from 'components/organisms/header'
import Webpage from 'components/organisms/webpage'
import React from 'react'

const AboutUsScreen: React.FC = () => {
  return (
    <Webpage title="Quem nós somos">
      <Header />
      <NavBar active="who-we-are" />
      <Body className="">
        <Container>
          <Column className="py-8  ">
            <Text className="mt-lg mb-9 text-2xl font-bold text-indigo-600 sm:mb-14 ">
              Quem Somos
            </Text>
            <Column className="text-xs sm:text-sm">
              <InBetweenSpacing>
                <p>
                  O Supremo Concurso nasceu em agosto de 2009, a partir da
                  junção de dois grupos de professores de Belo Horizonte e do
                  Rio de janeiro, com mais de dez anos de experiência no mercado
                  preparatório.
                </p>
                <p>
                  Com professores renomados à frente do projeto, a intenção é
                  fornecer um serviço de máxima qualidade, seja para aqueles que
                  visam garantir sua reciclagem profissional, a frequência em
                  cursos de pós-graduação ou a aprovação em concursos públicos e
                  exame de Ordem.
                </p>
                <p>
                  Para se alcançar este objetivo, o curso baseia-se em quatro
                  grandes valores: excelência do corpo docente, atendimento
                  diferenciado ao aluno, organização administrativa e
                  infra-estrutura.
                </p>
                <p>
                  Para garantir aulas com conteúdo e didática, professores de
                  todo o Brasil são contratados para integrar a equipe Supremo.
                </p>
                <p>
                  O atendimento com atenção e educação, que pode ser sentido
                  desde o primeiro contato travado com o curso, é fruto de uma
                  seleção criteriosa de nosso corpo de colaboradores e de
                  treinamentos constantes.
                </p>
                <p>
                  Na organização administrativa, destaca-se a presença de nossa
                  coordenação, ouvindo os anseios dos alunos e cuidando dos
                  processos internos, fundamentais para a política de boa
                  gestão.
                </p>
                <p>
                  Já no quesito infra-estrutura, instalado no Centro de Belo
                  Horizonte, um prédio exclusivo no ponto nobre da cidade onde
                  são ministrados cursos presenciais, além de gravados os cursos
                  online para todo o Brasil.
                </p>
                <p>
                  Venha para o Supremo Concursos e surpreenda-se com o melhor
                  curso preparatório para concursos públicos!
                </p>
              </InBetweenSpacing>
            </Column>
          </Column>
        </Container>
      </Body>
      <Footer />
    </Webpage>
  )
}

export default AboutUsScreen
